export const colors = {
  error: '#E8212B',
  primary: '#5B36F2',
  text01: '#4F6168',
  text02: '#161D1F',
  white: '#FFFFFF'
};
